// extracted by mini-css-extract-plugin
module.exports = {"socialLinks":"PostSocialLinks--socialLinks--2Yb22","copyToClipboard":"PostSocialLinks--copyToClipboard--3lFlw"};